import React from "react";

export const LogoutIcon = ({ width = 25, height = 24, color = "black", className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      className={className}
    >
      <path
        d="M5.5 21C4.95 21 4.47933 20.8043 4.088 20.413C3.69667 20.0217 3.50067 19.5507 3.5 19V5C3.5 4.45 3.696 3.97933 4.088 3.588C4.48 3.19667 4.95067 3.00067 5.5 3H12.5V5H5.5V19H12.5V21H5.5ZM16.5 17L15.125 15.55L17.675 13H9.5V11H17.675L15.125 8.45L16.5 7L21.5 12L16.5 17Z"
        fill={color}
      />
    </svg>
  );
};
